// extracted by mini-css-extract-plugin
export default {"Calendar":"styles_Calendar__V-owk","scroll":"styles_scroll__Vqn7F","noFavorites":"styles_noFavorites__LR5bm"};